import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-20 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Icon name="Code2" size={20} />
            <span className="text-sm font-medium">Enterprise-Grade Integration Solutions</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-text-primary mb-6 leading-tight">
            Custom API Integrations That
            <span className="text-primary"> Scale Your Business</span>
          </h1>
          
          <p className="text-lg sm:text-xl text-text-secondary mb-8 max-w-3xl mx-auto leading-relaxed">
            Connect your entire tech stack seamlessly. Our expert developers build robust, scalable API integrations that eliminate data silos and automate complex workflows across any platform.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Link to="/contact">
              <Button 
                variant="default" 
                size="lg"
                iconName="Calendar"
                iconPosition="left"
              >
                Book Technical Consultation
              </Button>
            </Link>
            <Button 
              variant="outline" 
              size="lg"
              iconName="FileText"
              iconPosition="left"
            >
              Download Integration Guide
            </Button>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
            {[
              { value: '500+', label: 'APIs Integrated', icon: 'Plug' },
              { value: '99.9%', label: 'Uptime SLA', icon: 'Activity' },
              { value: '24/7', label: 'Support', icon: 'Headphones' },
              { value: '50+', label: 'Platforms', icon: 'Layers' }
            ].map((stat) => (
              <div key={stat.label} className="bg-card p-4 rounded-lg border border-border">
                <Icon name={stat.icon} size={24} className="text-primary mx-auto mb-2" />
                <div className="text-2xl font-bold text-text-primary mb-1">{stat.value}</div>
                <div className="text-sm text-text-secondary">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;